<template>
    <modal
        name="ruleModal"
        width="94%"
        :max-width="332"
        :adaptive="true"
        height="114px"
        @before-open="beforeOpen"
        @before-close="$emit('close')"
    >
        <div class="rule-modal">
            <div class="rule-modal-heading">
                <h4 class="rule-modal-title">
                    {{ title }}
                </h4>
                <div class="rule-modal-close" @click="$modal.hide('ruleModal')">
                    <img src="/images/icons/close_x.svg" alt="Close">
                </div>
            </div>
            <hr>
            <div class="rule-modal-content">
                <p v-html="content" />
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "RuleModal",
    data() {
        return {
            title: '',
            content: ''
        }
    },
    methods: {
        beforeOpen(event) {
            this.title = event.params.title;
            this.content = event.params.content;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.v--modal-overlay {
    background-color: rgba(0, 0, 0, 0.88) !important;
}

.rule-modal {
    &-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 17px 20px 16px 20px;
    }

    &-title {
        font-size: 20px;
        color: $black;
        margin: 0;
    }

    &-close {
        cursor: pointer;
    }

    &-content {
        padding: 17px 20px 16px 20px;

        p {
            color: #5f707f;
            font-size: 16px;
        }
    }

    hr {
        margin: 0;
        opacity: 0.2;
        border-top: 1px solid #485366;
    }
}
</style>
